export default __webpack_public_path__ + "270696196fb7c390262022c480a9bdca.png";